import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, cssVar } from '@chakra-ui/react';

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');

const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
  thumb: {
    bg: 'white',
  },
  track: {
    bg: 'M.30',
    _focus: {
      boxShadow: 'none',
    },
    _checked: {
      bg: 'iconAccent',
    },
    _disabled: {
      cursor: 'default',
      opacity: 0.4,
    },
  },
});

const sizes = {
  lg: {
    container: {
      [$height.variable]: '18px',
      [$width.variable]: '32px',
    },
  },
};

export const Switch = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: 'lg',
  },
});
